import {LOGBOOK_AVAILABLE_ASSIGNEES_REQUEST, LOGBOOK_LOAD_REQUEST} from "../config/actions";
import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import LogbookApi from "../apis/LogbookApi";
import {load_available_assignees_success, load_success, load_success_no_data} from "../actions/logbookAction";

const loadAvailableAssigneesFromApi = async () =>
    LogbookApi.loadAvailableAssignees()
        .then((response) => {
            if(response.data.success) return response.data.data;
            return null;
        });

function* doLoadAvailableAssignees() {
    try {
        const result = yield call(loadAvailableAssigneesFromApi);
        if(result) yield put(load_available_assignees_success(result));
    } catch(e) {
        console.log('error', e);
    }
}

function* loadAvailableAssignees() {
    yield takeEvery(LOGBOOK_AVAILABLE_ASSIGNEES_REQUEST, doLoadAvailableAssignees);
}


const loadLogbookFromApi = async (payload) =>
    LogbookApi.loadLogbookEntries(payload.lastUpdateCall)
        .then((response) => {
            if(response.data.success) {
                if(response.data.data.noData) {
                    return null;
                } else {
                    return response.data.data;
                }
            }
            return null;
        });

function* doLoadLogbook(data) {
    try {
        const result = yield call(loadLogbookFromApi, data.payload);
        if(result) {
            yield put(load_success(result));
        } else {
            yield put(load_success_no_data());
        }
    } catch(e) {
        console.log('error', e);
    }
}

export function* loadLogbook() {
    yield takeEvery(LOGBOOK_LOAD_REQUEST, doLoadLogbook);
}

export default function* rootSaga() {
    yield all([fork(loadLogbook), fork(loadAvailableAssignees)]);
}
